import React, { useRef } from 'react';
import Temple2 from '../../assets/temple2.png';
import Temple from '../../assets/temple_bg.png';
import Sponser1 from '../../assets/sponser1.png';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';

const Gallery = () => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const screenWidth = window.innerWidth;

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = screenWidth;
      current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const images = [Temple2, Temple, Sponser1, Temple, Temple2, Temple, Temple, Temple2, Temple];

  return (
    <div className="bg-[#fcc76d] py-10 px-4 sm:px-6 md:px-10">
      <h1 className="text-3xl sm:text-4xl font-bold text-[#4C3A2B] text-center mb-4">
        Gallery
      </h1>
      <div className="w-full flex justify-end mt-2 mb-2">
        <button onClick={() => navigate('/gallery')}
        className="rounded-full px-4 py-2 bg-[#fcd38d] text-sm font-semibold">
          See more...
        </button>
      </div>

      {/* Image Slider */}
      <div className="relative w-full">
        <HiChevronLeft
          size={50}
          onClick={() => scroll('left')}
          className="hidden md:block absolute top-[50%] left-3 z-10 transform -translate-y-1/2 text-[#4C3A2B]  p-2 cursor-pointer"
        />
        <HiChevronRight
          size={50}
          onClick={() => scroll('right')}
          className="hidden md:block absolute top-[50%] right-3 z-10 transform -translate-y-1/2 text-[#4C3A2B]  p-2 cursor-pointer"
        />
        <div
          ref={scrollRef}
          className="flex overflow-x-auto scroll-smooth scrollbar-hide gap-4 sm:gap-6 md:gap-8 cursor-pointer py-5"
        >
          {images.map((img, index) => (
            <div key={index} className="min-w-[80%] sm:min-w-[300px] md:min-w-[350px] h-[200px] sm:h-[250px] md:h-[300px] rounded-md overflow-hidden flex-shrink-0">
              <img
               key={index}
                src={img}
                alt={`slide-${index}`}
                className="w-full h-full object-cover object-center transition-all ease-in-out duration-200 hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
